import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Button } from "../../../../../../../../components/ui/Button";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import I18n from "../../../../../../../localization/I18n";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { StakeholderEmailsModel } from "./StakeholderEmails_model";

export const StakeholderEmails: React.FC<{ itemIds: number[]; projectId: number }> = observer(
  ({ itemIds, projectId }) => {
    const organisationId = useCurrentOrganisationId();
    const [model] = useState(() => new StakeholderEmailsModel(organisationId, projectId, itemIds));

    const emailList = model.stakeholders.map(e => e.email).join(",");

    useEffect(() => {
      model.onMount();
    }, [model]);

    if (model.isLoading) {
      return (
        <div className="stakeholder-email container-fluid py-6">
          <PositionedSpinner />
        </div>
      );
    }

    return (
      <div className="stakeholder-email container-fluid py-6">
        <div className="row">
          <div className="col">
            <h1 className="mb-1">Email Addresses</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <ul className="my-0 mb-3">
              {model.stakeholders?.length > 0
                ? model.stakeholders.map((email, i) => {
                    return (
                      <li className="stakeholder-email__list" key={i}>
                        <p className="mb-0">{email}</p>
                      </li>
                    );
                  })
                : I18n.t("phrases.actionStakeholders_noEmailAddresses")}
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Button
              onClick={() => {
                navigator.clipboard.writeText(emailList);
              }}
              className="mr-2"
            >
              {I18n.t("phrases.copyToClipboard")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
);
